import { create } from 'zustand';

/**
 * Zustand store for managing the FloatingDocumentChat state
 * Used to communicate between OnGov panels and the floating chat component
 */
export const useFloatingChatStore = create((set, get) => ({
  // State
  isOpen: false,
  query: '',
  scope: 'both',

  // Actions
  /**
   * Open the floating chat with a pre-filled query
   * @param {string} query - The query to pre-fill in the chat
   * @param {string} scope - The document scope ('both', 'personal', 'organization', 'department', 'public')
   */
  openChatWithQuery: (query, scope = 'both') => {
    set({
      isOpen: true,
      query: query.trim(),
      scope,
    });
  },

  /**
   * Close the floating chat and clear the query
   */
  closeChatWithQuery: () => {
    set({
      isOpen: false,
      query: '',
    });
  },

  /**
   * Set the document scope
   * @param {string} scope - The document scope ('both', 'personal', 'organization', 'department', 'public')
   */
  setScope: (scope) => {
    set({ scope });
  },

  /**
   * Set the query text
   * @param {string} query - The query text
   */
  setQuery: (query) => {
    set({ query });
  },

  // Utility methods
  /**
   * Reset the chat to its initial state
   */
  resetChat: () => {
    set({
      isOpen: false,
      query: '',
      scope: 'both',
    });
  },
}));
